import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1119de25"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, [
  /*#__PURE__*/_createTextVNode("First Name"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, [
  /*#__PURE__*/_createTextVNode("Last Name"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, [
  /*#__PURE__*/_createTextVNode("Phone"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "howManyTickets" }, "How many tickets to sell?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "eventLocation" }, "Event location (suburb/town)", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "eventLocationState" }, "State", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose a state", -1))
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Description"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "secondary-button",
  type: "submit",
  value: "Submit"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    class: "contact-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_Field, {
          name: "firstName",
          id: "firstName",
          modelValue: _ctx.formData.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.firstName) = $event)),
          type: "text",
          "aria-describedby": "firstName__error",
          rules: _ctx.validation.firstName
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "firstName__error",
          class: "contact-form__error",
          name: "firstName"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_Field, {
          name: "lastName",
          id: "lastName",
          modelValue: _ctx.formData.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.lastName) = $event)),
          type: "text",
          "aria-describedby": "lastName",
          rules: _ctx.validation.lastName
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "lastName__error",
          class: "contact-form__error",
          name: "lastName"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_Field, {
          name: "phone",
          id: "phone",
          modelValue: _ctx.formData.phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.phone) = $event)),
          type: "text",
          "aria-describedby": "phone__error",
          rules: _ctx.validation.phone
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "phone__error",
          class: "contact-form__error",
          name: "phone"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_Field, {
          name: "email",
          id: "email",
          modelValue: _ctx.formData.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
          type: "text",
          "aria-describedby": "email__error",
          rules: _ctx.validation.email
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "email__error",
          class: "contact-form__error",
          name: "email"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_component_Field, {
          name: "howManyTickets",
          id: "howManyTickets",
          modelValue: _ctx.formData.howManyTickets,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.howManyTickets) = $event)),
          type: "text",
          "aria-describedby": "howManyTickets__error",
          rules: _ctx.validation.howManyTickets
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "howManyTickets__error",
          class: "contact-form__error",
          name: "howManyTickets"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_Field, {
          name: "eventLocation",
          id: "eventLocation",
          modelValue: _ctx.formData.eventLocation,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.eventLocation) = $event)),
          type: "text",
          "aria-describedby": "eventLocation__error",
          rules: _ctx.validation.eventLocation
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "eventLocation__error",
          class: "contact-form__error",
          name: "eventLocation"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _createVNode(_component_Field, {
          name: "eventLocationState",
          id: "eventLocationState",
          modelValue: _ctx.formData.eventLocationState,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.eventLocationState) = $event)),
          as: "select",
          "aria-describedby": "eventLocationState__error",
          rules: _ctx.validation.eventLocationState
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventLocationStates, (eventLocationState) => {
              return (_openBlock(), _createElementBlock("option", {
                key: eventLocationState.value,
                value: eventLocationState.value,
                selected: 
            eventLocationState.value &&
            _ctx.formData.eventLocationState.includes(eventLocationState.value)
          
              }, _toDisplayString(eventLocationState.label), 9, _hoisted_9))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "eventLocationState__error",
          class: "contact-form__error",
          name: "eventLocationState"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _createVNode(_component_Field, {
          name: "eventDescription",
          modelValue: _ctx.formData.eventDescription,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.eventDescription) = $event)),
          "aria-describedby": "description__error",
          rules: _ctx.validation.eventDescription
        }, {
          default: _withCtx(({ field }) => [
            _createElementVNode("textarea", _mergeProps({ id: "description" }, field, { rows: "5" }), null, 16)
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "description__error",
          class: "contact-form__error",
          name: "description"
        })
      ]),
      _hoisted_11
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}